import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap, startWith } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';
import ValueFromSliderChanged from '../events/ValueFromSliderChanged';
import OrderSetBaseOnLiabilitySucceed from '../events/OrderSetBaseOnLiabilitySucceed';
import OrderSetBaseOnLiabilityFailed from '../events/OrderSetBaseOnLiabilityFailed';
import OrderSetBaseOnLiabilityRequested from '../events/OrderSetBaseOnLiabilityRequested';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(ValueFromSliderChanged.type),
        mergeMap((event: ValueFromSliderChanged) => {
            return backend.get(`${api()}orders/putValues/` + event.sliderValue).pipe(
                map((ajaxResponse: AjaxResponse) => new OrderSetBaseOnLiabilitySucceed(ajaxResponse.response)),
                startWith(new OrderSetBaseOnLiabilityRequested()),
                catchError((e: AjaxError) => of(new RequestFailed(e.status), new OrderSetBaseOnLiabilityFailed()))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/order/epic/orderSetBaseOnLiability.ts